export const enPartners = {
  "our": "OUR",
  "title": "PARTNERS",
  "subTitle": "STRONGER THROUGH PARTNERSHIPS",
  "description": "Our partners are at the heart of our growth. Through strong collaborations and shared values, we build long-lasting relationships that drive mutual success and innovation.",
  partner1: {
    name: "RNJ Advisory",
    description: "Legal & strategic advisory for entrepreneurs, SMEs and institutions in Belgium, Tunisia & Africa.",
    website: "https://www.rnj-advisory.be/"
  },
  
};

export const frPartners = {
  "our": "NOS",
  "title": "PARTENAIRES",
  "subTitle": "PLUS FORTS GRÂCE AUX PARTENARIATS",
  "description": "Nos partenaires sont au cœur de notre croissance. Grâce à des collaborations solides et des valeurs partagées, nous construisons des relations durables qui favorisent le succès mutuel et l'innovation.",
  partner1: {
    name: "RNJ Advisory",
    description: "Conseils juridiques & stratégiques pour les entrepreneurs, PME et institutions en Belgique,Tunisie & Afrique.",
    website: "https://www.rnj-advisory.be/"
  },
 
};
export const nlPartners = {
  "our": "ONZE",
  "title": "PARTNERS",
  "subTitle": "STERKER DOOR PARTNERSHIPS",
  "description": "Onze partners staan centraal in onze groei. Door sterke samenwerkingen en gedeelde waarden bouwen we langdurige relaties op die wederzijds succes en innovatie stimuleren.",
  partner1: {
    name: "RNJ Advisory",
    description: "Juridisch & strategisch advies voor ondernemers, KMO's en instellingen in België, Tunesië & Afrika.",
    website: "https://www.rnj-advisory.be/"
  },
  
};
export const dePartners = {
  "our": "UNSERE",
  "title": "PARTNER",
  "subTitle": "STÄRKER DURCH PARTNERSCHAFTEN",
  "description": "Unsere Partner stehen im Mittelpunkt unseres Wachstums. Durch starke Kooperationen und geteilte Werte bauen wir langfristige Beziehungen auf, die gegenseitigen Erfolg und Innovation vorantreiben.",
  partner1: {
    name: "RNJ Advisory",
    description: "Rechts- & Strategieberatung für Unternehmer, KMU und Institutionen in Belgien, Tunesien & Afrika.",
    website: "https://www.rnj-advisory.be/"
  },
 
};